export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-34.ac4a5e49.jpg";